/*
 * Copyright © 2015-2020 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import CustomAttributesDetailsPanel from './layout';

export default connect()(CustomAttributesDetailsPanel);
